import { network } from 'services/network';
import { useMutation } from 'react-query';

const resetConfigParams = (params) => {
    return network.post('api/bo/resetConfigOfSingleChecker', params).then((response) => {
        return response.data;
    });
};
export const useMutationResetConfigParams = () => {
    return useMutation<any, QueryError, IResetConfigParams>('resetConfigParams', (params) => resetConfigParams(params));
};

interface IResetConfigParams {
    configId: number;
    metaDataId: number;
}
